<template>
    <div>

        <div class="container">
            <div class="brand my-5 mx-auto" style="width: 150px !important; height: 50px !important;">
                <img src="~@/assets/logo.png" border="0" style="width: 100%;" />
            </div>

            <div class="row justify-content-center align-items-center">
                <div class="col col-lg-5 col-md-6">
                    <div class="card shadow-sm">
                        <div class="card-body">

                            <template v-if="isStandardLogin">
                                <h4 class="card-title mb-3 text-center">Login</h4>
                                <div class="mb-2">
                                    <label class="form-label">Email</label>
                                    <input type="email" class="form-control" id="emailField" v-model="email">
                                </div>
                                <div class="mb-2">
                                    <label class="form-label">Password</label>
                                    <input type="password" class="form-control" id="pswField" v-model="password">
                                </div>
                                <div class="d-grid gap-2">
                                    <button type="button" class="btn btn-primary" @click="onSignIn">Login</button>
                                </div>
                                <div class="mb-2">
                                    <a class="float-end text-end small" :href="forgotPasswordLink">Forgot Password?</a>
                                </div>
                            </template>
                            <template v-if="isPasswordlessLogin">
                                <h4 class="card-title mb-3 text-center">Login - Passwordless</h4>
                                <div class="mb-3">
                                    <label for="pswlessEmail" class="form-label">Email</label>
                                    <input type="email" class="form-control" id="pswlessEmail" v-model="passwordlessEmail" :readonly="hasCurrentUser">
                                </div>
                                <div class="mb-3" v-if="hasCurrentUser">
                                    <label for="pswlessEmail" class="form-label">Secret Code</label>
                                    <input type="text" class="form-control" id="pswlessEmail" v-model="secretCode">
                                    <small class="form-text text-muted">We have sent you an email. Check the inbox, and the spam too!</small>
                                </div>
                                <div class="d-grid gap-2">
                                    <button type="button" class="btn btn-primary" v-if="!hasCurrentUser" @click="onSignInPasswordless">Request Code</button>
                                    <button type="button" class="btn btn-primary" v-if="hasCurrentUser" @click="onConfirmCode">Confirm Code</button>
                                </div>
                            </template>

                            <h5 class="text-center mt-5 mb-0 ">Otherwise</h5>
                            <hr />

                            <div class="d-grid gap-2">
                                <button class="btn btn-primary btn-block" @click="setIsPasswordless(false)" v-if="isPasswordlessLogin">
                                    <span class="fa fa-key"></span> Login with Password
                                </button>
                                <button class="btn btn-primary btn-block" @click="setIsPasswordless(true)" v-if="isStandardLogin">
                                    <span class="fa fa-envelope"></span> Login - Passwordless
                                </button>
                                <button type="button" class="btn btn-primary btn-block" @click="onSignInWithGoogle">
                                    <span class="fa fa-google"></span> Login with Google
                                </button>
                                <button type="button" class="btn btn-primary btn-block" @click="onSignInWithFacebook">
                                    <span class="fa fa-facebook"></span> Login with Facebook
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="text-secondary my-3 text-center">
                &copy; {{ new Date().getFullYear() }} - V-EXPO
            </div>
        </div>

    </div>
</template>

<script>
    import AuthServices from "../app/auth-services";
    export default {
        name: 'SignIn',
        data: function () {
            return {
                email: null,
                password: null,

                passwordlessEmail: null,
                secretCode: null,
                currentUser: null,

                isStandardLogin: true,
                isPasswordlessLogin: false,
            };
        },
        computed: {
            hasCurrentUser() {
                return this.currentUser !== null;
            },
            title() {
                return process.env.VUE_APP_EXHIBITION_NAME || 'VexpoSite';
            },
            forgotPasswordLink() {
                return process.env.VUE_APP_FORGOT_PASSWORD_LINK;
            },
        },
        methods: {
            setIsPasswordless(value) {
                this.isPasswordlessLogin = value;
                this.isStandardLogin = !value;
            },

            async onSignIn() {
                try {
                    this.$store.dispatch('setLoading', true);
                    await AuthServices.signIn(this.email, this.password);
                    //let param = this.$store.getters.initialQuery;
                    //this.$router.push({ name: 'Home', params: param });
                    await this.getNickname();
                }
                catch (e) {
                    if (e.code && e.code == 'UserNotConfirmedException') {
                        let redirectUrl = new URL(process.env.VUE_APP_COMPLETE_REGISTRATION_URL)
                        redirectUrl.searchParams.append('sub', 'UserNotConfirmed');
                        redirectUrl.searchParams.append('email', this.email);
                        redirectUrl.searchParams.append('callback', window.location.origin);
                        window.location.href = redirectUrl.href;
                        return;
                    }
                    this.$store.dispatch('setErrorNotification', 'onSignIn error: ' + e.message);
                }
                finally {
                    this.$store.dispatch('setLoading', false);
                }
            },
            async onSignInPasswordless() {
                try {
                    this.$store.dispatch('setLoading', true);
                    this.currentUser = await AuthServices.signInPasswordless(this.passwordlessEmail);
                }
                catch (e) {
                    this.$store.dispatch('setErrorNotification', 'onSignInPasswordless error: ' + e.message);
                }
                finally {
                    this.$store.dispatch('setLoading', false);
                }
            },
            async onConfirmCode() {
                try {
                    this.$store.dispatch('setLoading', true);
                    await AuthServices.checkAnswer(this.currentUser, this.secretCode);
                    //let param = this.$store.getters.initialQuery;
                    //this.$router.push({ name: 'Home', params: param });
                    await this.getNickname();
                }
                catch (e) {
                    if (e.code && e.code == 'UserNotConfirmedException') {
                        let redirectUrl = new URL(process.env.VUE_APP_COMPLETE_REGISTRATION_URL)
                        redirectUrl.searchParams.append('sub', 'UserNotConfirmed');
                        redirectUrl.searchParams.append('email', this.passwordlessEmail);
                        redirectUrl.searchParams.append('callback', window.location.origin);
                        window.location.href = redirectUrl.href;
                        return;
                    }
                    this.$store.dispatch('setErrorNotification', 'onConfirmCode error.');
                }
                finally {
                    this.$store.dispatch('setLoading', false);
                }
            },
            async onSignInWithGoogle() {
                try {
                    await AuthServices.signInWithGoogle();
                } catch (error) {
                    console.log('error onSignInWithGoogle', error);
                    throw error;
                }
            },
            async onSignInWithFacebook() {
                await AuthServices.signInWithFacebook();
            },

            async getNickname() {
                await this.$store.dispatch('getNickname');
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .signin {
        position: absolute;
        top: 0;
        bottom: 0;
    }
    .center-column {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .logo {
        width:100%;
        max-width:300px;
        max-height:300px;
        display:block;
    }
</style>

